import { isLocalDevServerHostname } from "#is-local-dev-server-hostname";
import { isLoopbackHostname } from "#is-loopback-hostname";

const TRAILING_SLASH_REGEX = /\/$/;

/**
 * Point a dev stack's loopback service URL at the host the dev client actually reached.
 *
 * A dev stack inlines its local services (such as the static-DB worker) as loopback URLs. A
 * simulator shares the Mac's loopback, but a physical device does not: its loopback is the phone.
 * When the bundle came from a dev server at a network address (`vpx _dev --lan`, or an iPhone's USB
 * hotspot), use that host and keep the service's own port. A loopback or tunnel `hostUri`, a
 * standalone build without one, and a non-loopback URL are left as they are.
 */
export function toDevServerReachableUrl(url: string, hostUri: string | null | undefined): string {
  if (hostUri == null || hostUri.length === 0) {
    return url;
  }
  let devServerHostname: string;
  let target: URL;
  try {
    devServerHostname = new URL(`http://${hostUri}`).hostname;
    target = new URL(url);
  } catch {
    return url;
  }
  if (
    !isLoopbackHostname(target.hostname) ||
    isLoopbackHostname(devServerHostname) ||
    !isLocalDevServerHostname(devServerHostname)
  ) {
    return url;
  }
  target.hostname = devServerHostname;
  const reachable = target.toString();
  return url.endsWith("/") ? reachable : reachable.replace(TRAILING_SLASH_REGEX, "");
}
